

























































































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import {PutServicesTempRequestData, OriginalAddress} from 'supporter';
import {ncpPopup} from '@/utils/ncp';
import { toI18n } from '@/utils/commonUtils';

interface Address extends OriginalAddress {
  isJibunSelected: string;
  zipCd: string;
  streetAddress: string;
  streetAddressExtra: string;
  jibunAddressDetail: string;
}

@Component
export default class ServiceRegisterForm extends Vue {
  @Prop() private serviceData: any;

  private serviceName: string = '';
  private memo: string = '';
  private data: PutServicesTempRequestData = {
    address: {
      zipCode: '',

      address: '',
      detailAddress: '',

      jibun: '',
      jibunDetail: ''
    },
    permittedIpAddress: '',
    faxNo: '',
    privacyManager: {
      name: '',
      position: '',
      team: '',
      email: '',
      phoneNo: ''
    },
    representative: {
      name: '',
      email: '',
      phoneNo: ''
    },
    business: {
      condition: '',
      registrationNo: '',
      type: '',
      onlineMarketingDeclarationNo: ''
    },
    tempCode: '',
    companyName: ''
  };

  private popup: Window | null = null;

  private bShowGuide: boolean = false;

  /**
   * data init from parent view data
   */
  @Watch('serviceData')
  onServiceDataChange (): void {
    this.serviceName = this.serviceData.serviceName;

    this.memo = this.serviceData.memo;

    this.data.address.address = this.serviceData.address.address || '';
    this.data.address.detailAddress = this.serviceData.address.detailAddress || '';
    this.data.address.jibun = this.serviceData.address.jibun || '';
    this.data.address.jibunDetail = this.serviceData.address.jibunDetail || '';
    this.data.address.zipCode = this.serviceData.address.zipCode || '';

    this.data.permittedIpAddress = this.serviceData.permittedIpAddress || '';
    this.data.faxNo = this.serviceData.faxNo || '';
    this.data.companyName = this.serviceData.companyName || '';

    this.data.privacyManager.name = this.serviceData.privacyManager.name || '';
    this.data.privacyManager.position = this.serviceData.privacyManager.position || '';
    this.data.privacyManager.team = this.serviceData.privacyManager.team || '';
    this.data.privacyManager.email = this.serviceData.privacyManager.email || '';
    this.data.privacyManager.phoneNo = this.serviceData.privacyManager.phoneNo || '';

    this.data.representative.name = this.serviceData.representative.name || '';
    this.data.representative.email = this.serviceData.representative.email || '';
    this.data.representative.phoneNo = this.serviceData.representative.phoneNo || '';

    this.data.business.condition = this.serviceData.business.condition || '';
    this.data.business.registrationNo = this.serviceData.business.registrationNo || '';
    this.data.business.onlineMarketingDeclarationNo = this.serviceData.business.onlineMarketingDeclarationNo || '';
    this.data.business.type = this.serviceData.business.type || '';
  }

  get emailId (): string {
    return this.data.representative.email.split('@')[0];
  }
  set emailId (id: string) {
    const domain: string = this.data.representative.email.split('@')[1] || '';
    this.data.representative.email = `${id}@${domain}`;
    if (this.data.representative.email === '@') {
      this.data.representative.email = '';
    }
  }

  get emailDomain (): string {
    return this.data.representative.email.split('@')[1] || '';
  }
  set emailDomain (domain: string) {
    this.data.representative.email = this.data.representative.email.split('@')[0] + '@' + domain;
    if (this.data.representative.email === '@') {
      this.data.representative.email = '';
    }
  }

  created () {
    this.data.tempCode = this.$route.query.tempCode as string;

    this.$emit('getServiceTemp');
  }

  /**
   * put services info
   */
  private putServicesTemp (): Promise<boolean> {
    return this.$api.putServicesTemp({ data: this.data })
      .then(response => {
        if (response && response.status === 204) {
          return true;
        }
        else {
          return false;
        }
      })
      .catch(() => {
        return false;
      });
  }

  private showGuide (): void {
    this.bShowGuide = true;
  }
  private hideGuide(): void {
    this.bShowGuide = false;
  }

  /**
   * open address find popup
   */
  private openAddressFindPopup () {
    if (this.popup && !this.popup.closed) {
      return;
    }

    (window as any).receiveAddressCallback = this.receiveAddressCallback;
    this.popup = ncpPopup('/address/search/popup?dataCallback=receiveAddressCallback', '_blank', 1000, 670);
  }
  private receiveAddressCallback (address: Address): void {
    if (address) {
      this.data.address.zipCode = address.zipCode || '';
      this.data.address.address = address.streetAddress || '';
      this.data.address.detailAddress = address.streetAddressExtra || '';
      this.data.address.jibun = address.jibunAddress || '';
      this.data.address.jibunDetail = address.jibunAddressDetail || '';
    }
  }

  /**
   * check input valid before put service data
   */
  private isFormPassed (): boolean {
    if (this.data.companyName.trim().length === 0) {
      alert(this.toI18n('REGISTER_ALERT_INSERT_COMPANY_NAME'));
      (this.$refs.companyName as HTMLElement).focus();
      return false;
    }

    if (this.data.business.registrationNo.trim().length === 0) {
      alert(this.toI18n('REGISTER_ALERT_INSERT_BUSINESS_NUMBER'));
      (this.$refs.businessRegistrationNo as HTMLElement).focus();
      return false;
    }

    if (this.data.representative.name.trim().length === 0) {
      alert(this.toI18n('REGISTER_ALERT_INSERT_REPRESENTATIVE_NAME'));
      (this.$refs.representativeName as HTMLElement).focus();
      return false;
    }

    if (this.data.business.type.trim().length === 0) {
      alert(this.toI18n('REGISTER_ALERT_INSERT_BUSINESS_TYPE'));
      (this.$refs.businessType as HTMLElement).focus();
      return false;
    }

    if (this.data.business.condition.trim().length === 0) {
      alert(this.toI18n('REGISTER_ALERT_INSERT_BUSINESS_CONDITION'));
      (this.$refs.businessCondition as HTMLElement).focus();
      return false;
    }

    if (this.data.representative.phoneNo.trim().length === 0) {
      alert(this.toI18n('REGISTER_ALERT_INSERT_REPRESENTATIVE_PHONE'));
      return false;
    }

    if (this.emailId.trim().length === 0 || this.emailDomain.trim().length === 0) {
      alert(this.toI18n('REGISTER_ALERT_INSERT_REPRESENTATIVE_EMAIL'));
      return false;
    }

    if (this.data.address.zipCode.trim().length === 0 || this.data.address.address.trim().length === 0 || this.data.address.jibun.trim().length === 0) {
      alert(this.toI18n('REGISTER_ALERT_INSERT_ADDRESS'));
      return false;
    }

    if (!this.checkIpAddressInput()) { // 접속 IP 설정 체크
      return false;
    }

    return true;
  }

  /**
   * check ip address valid
   */
  private checkIpAddressInput (): boolean {
    const ipInputString = this.data.permittedIpAddress;
    const ipInputStringLengthCheck = ipInputString.replace(/(\r\n|\n|\r)/g,'  ');
    if (ipInputStringLengthCheck.length > 1000) {
      alert(this.toI18n('REGISTER_ALERT_IP_MAX_NUM'));
      return false;
    }

    const ipInput = ipInputString.split('\n').filter(function (ip) {
      return ip.length != 0
    });
    const charPattern = /([0-9.\\-])+/;
    const rangeIpPattern = /^[^-]*-[^-]*$/;
    const ipPattern = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$|^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9\-]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9\-]*[A-Za-z0-9])$|^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;

    for (let i = 0; i < ipInput.length; i++) {
      // check for range input
      if (!ipInput[i].match(charPattern)) {
        alert(this.toI18n('REGISTER_ALERT_IP_WRONG_ADDRESS'));
        return false;
      }
      else if (ipInput[i].match(rangeIpPattern)) {
        let range = ipInput[i].split('-');
        let start = range[0].substr(range[0].lastIndexOf('.') + 1, range[0].length + 1);
        let end = range[1].substr(range[1].lastIndexOf('.') + 1, range[1].length + 1);
        range[1] = range[0].substring(0, range[0].lastIndexOf('.') + 1) + end;

        if ((!range[0].match(ipPattern) || !range[1].match(ipPattern)) || (start >= end)) {
          alert(this.toI18n('REGISTER_ALERT_IP_WRONG_ADDRESS'));
          return false;
        }
      }
      else if (!ipInput[i].match(ipPattern)) {
        alert(this.toI18n('REGISTER_ALERT_IP_WRONG'));
        return false;
      }
    }
    return true;
  }

  private nextStep (): void {
    if (!this.isFormPassed()) {
      return;
    }

    this.putServicesTemp()
      .then((success: boolean) => {
        if (success) {
          this.$router.push('/admin/service/master/registerForm?tempCode=' + this.data.tempCode);
        }
      });
  }

  private toI18n (needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'SERVICE_REGISTER_') + needToI18nStr));
  }
}
